import React from 'react';
import SingleService from '../../../components/SingleService/SingleService';

const HomeServices = () => {
   return (
      <>
         <section className="services__area pt-115 pb-80">
            <div className="container">
               <div className="row">
                  <div className="col-xl-8 offset-xl-2 col-lg-10 offset-lg-1">
                     <div className="section__title section__title-3 text-center mb-90 wow fadeInUp" data-wow-delay=".2s">
                        <span>Nuestros Servicios</span>
                        <h2>Transformamos Dolor en Esperanza con Nuestros Servicios.</h2>
                     </div>
                  </div>
               </div>
               <div className="row">

                  <SingleService icon="1" title="Atención Médica Integral" />
                  <SingleService icon="2" title="Soporte Psicológico Profundo" />
                  <SingleService icon="3" title="Asistencia Legal Dedicada" />
                  <SingleService icon="4" title="Programas de Apoyo Familiar" />
                  <SingleService icon="5" title="Educación y Prevención" />
                  <SingleService icon="6" title="Activismo y Concienciación" />

               </div>
            </div>
         </section>
      </>
   );
};

export default HomeServices;